// extracted by mini-css-extract-plugin
export default {"inlineAdWrapper":"dN-z","inlineTitle":"eN-z","sponsoredAdsWrapper":"fN-z","marketplaceRecosWrapper":"gN-z"};